import React, { useState, useEffect } from "react";

const MovingTitle = ({ className, title = "" }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleMouseMove = (event) => {
      const elements = document.getElementsByClassName(className);

      if (elements.length > 0) {
        const boundingBox = elements[0].getBoundingClientRect();
        const mouseX = event.pageX;
        const mouseY = event.pageY;

        // Check if the mouse is within the bounding box
        if (
          mouseX >= boundingBox.left &&
          mouseX <= boundingBox.right &&
          mouseY >= boundingBox.top &&
          mouseY <= boundingBox.bottom
        ) {
          setPosition({ x: mouseX + 10, y: mouseY + 10 });
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      }
    };

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, [className]);

  const titleStyle = {
    position: "absolute",
    left: `${position.x}px`,
    top: `${position.y}px`,
    backgroundColor: "#f8f8f8",
    padding: "5px",
    border: "1px solid #ccc",
    display: isVisible ? "block" : "none",
  };

  return <div style={titleStyle}>{title && title}</div>;
};

export default MovingTitle;
